module.exports = __webpack_public_path__ + "static/media/9.99d3ac8c.svg";